import {AbstractControl, ValidatorFn} from '@angular/forms';

export function accessorialsValidator(transportType: any, ratetypeid: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (ratetypeid === 11) {
      return null;
    }
    if (control.value !== null && (/^-?\d*\.?\d+$/).test(control.value)) {
      const acc = control.value;
      if (transportType === 'International') {
        return ((+acc === 0) ? {acczero: true} : (+acc < 0) ? {accnegative:true} : null);
      } else {
        return (+acc > 0 ? {accnotzero: true} : (+acc < 0) ? {accnegative:true} : null);
      }
      return null;
    }else if(control.value === ""){
      if(transportType === "Intrastate"){
        return {accnotzero: true};
      }else{
        return {acczero: true};
      }

    }
  };
}

export function linehaulValidator(transportType: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== null) {
      if (transportType === 'International') {
        // return null;
        if (control.value <= 0) {
          return {min: true};
        } else {
          return null;
        }
      }
      const linehaul = control.value;
      if (linehaul === 0) {
        return {min: true};
      } else if (linehaul > 60 && linehaul<=100) {
        return {overpoints: true};
      } else  if(linehaul > 100){
        return {max: true};
      }
    }
    return null;
  };
}

export function cv1Validator(transportType: any, sroid: any, ratetypeid: any, originid: any, destinationid: any,
                             alaskaorig: any, alaskadest: any, canadaOrig: any, canadaDest: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== null) {
      const cv1 = control.value;
      if (Number(cv1) < 0) {
        return {negativeVal: true};
      }
      if ((+cv1 <= 0) && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11)) {
        return {cat11: true};
      }
      if ((+cv1 / 100 <= 0) && (ratetypeid === 11)) {
        return {cat12: true};
      }
      if ((+cv1 / 100 > 99.00) && (ratetypeid === 11)) {
        return {class1warn1: true};
      }
      if (transportType === 'International' && (sroid === 'DOSHW' || sroid === 'FDICC') && (+cv1 > 0  || cv1 === '')) {
        return {class1warn10: true};
      }
      if ((transportType === 'International') && (sroid !== 'DOSHW') &&
        (alaskaorig.includes(originid) || alaskadest.includes(destinationid))) {
        if (+cv1 < 5) {
          return {class1warn3: true};
        } else if (+cv1 > 20000) {
          return {class1warn5: true};
        }
      }
      if ((transportType === 'International') && (sroid !== 'DOSHW' && sroid !== 'FDICC')) {
        if (+cv1 < 1000) {
          return {class1warn4: true};
        } else if (+cv1 > 20000) {
          return {class1warn5: true};
        }
      }
      if ((transportType === 'Interstate') && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11) &&
        (alaskaorig.includes(originid) || alaskadest.includes(destinationid))) {
        if (+cv1 < 5) {
          return {class1warn7: true};
        } else if (+cv1 > 20000) {
          return {class1warn8: true};
        }
      }
      if ((transportType === 'Interstate') && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11)) {
        if (+cv1 > 0 && +cv1 < 30) {
          return {class1warn2: true};
        } else if (+cv1 > 20000) {
          return {class1warn5: true};
        }
      }
      if (transportType === 'Intrastate' && sroid === 'FDICC' && (+cv1 > 0  || cv1 === '')) {
        return {class1warn10: true};
      }
      if (transportType === 'Intrastate') {
        if (+cv1 > 0 && +cv1 < 30) {
          return {class1warn9: true};
        }
      }
    }
    return null;
  };
}

export function cv2Validator(transportType: any, sroid: any, ratetypeid: any, originid: any, destinationid: any,
                             alaskaorig: any, alaskadest: any, canadaOrig: any, canadaDest: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== null) {
      const cv2 = control.value;
      if (Number(cv2) < 0) {
        return {negativeVal: true};
      }
      if ((+cv2 <= 0) && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11)) {
        return {cat21: true};
      }
      if ((+cv2 / 100 <= 0) && (ratetypeid === 11)) {
        return {cat22: true};
      }
      if ((+cv2 / 100 > 99.00) && (ratetypeid === 11)) {
        return {class2warn1: true};
      }
      if (transportType === 'International' && (sroid === 'DOSHW' || sroid === 'FDICC') && (+cv2 > 0  || cv2 === '')) {
        return {class2warn10: true};
      }
      if ((transportType === 'International') && (sroid !== 'DOSHW' && sroid !== 'FDICC') &&
        (alaskaorig.includes(originid) || alaskadest.includes(destinationid))) {
        if (+cv2 < 5) {
          return {class2warn3: true};
        } else if (+cv2 > 20000) {
          return {class2warn5: true};
        }
      }
      if ((transportType === 'International') && (sroid !== 'DOSHW' && sroid !== 'FDICC')) {
        if (+cv2 < 1000) {
          return {class2warn4: true};
        } else if (+cv2 > 20000) {
          return {class2warn5: true};
        }
      }
      if ((transportType === 'Interstate') && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11) &&
        (alaskaorig.includes(originid) || alaskadest.includes(destinationid))) {
        if (+cv2 < 5) {
          return {class2warn3: true};
        } else if (+cv2 > 20000) {
          return {class2warn5: true};
        }
      }
      if ((transportType === 'Interstate') && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11)) {
        if (+cv2 < 30) {
          return {class2warn6: true};
        } else if (+cv2 > 20000) {
          return {class2warn5: true};
        }
      }
      if (transportType === 'Intrastate' && (sroid === 'FDICC') && (+cv2 > 0  || cv2 === '')) {
        return {class2warn10: true};
      }
      if (transportType === 'Intrastate') {
        if (+cv2 > 0 && +cv2 < 30) {
          return {class2warn9: true};
        }
      }
    }
    return null;
  };

}

export function cv3Validator(transportType: any, sroid: any, ratetypeid: any, originid: any, destinationid: any,
                             alaskaorig: any, alaskadest: any, canadaOrig: any, canadaDest: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== null) {
      const cv3 = control.value;
      if (Number(cv3) < 0) {
        return {negativeVal: true};
      }
      if ((+cv3 <= 0) && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11)) {
        return {cat31: true};
      }
      if ((+cv3 / 100 <= 0) && (ratetypeid === 11)) {
        return {cat32: true};
      }
      if ((+cv3 / 100 > 99.00) && (ratetypeid === 11)) {
        return {class3warn1: true};
      }
      if (transportType === 'International' && (sroid === 'DOSHW' || sroid === 'FDICC') && (+cv3 > 0 || cv3 === '')) {
        return {class3warn10: true};
      }
      if ((transportType === 'International') && (sroid !== 'DOSHW' && sroid !== 'FDICC') &&
        (alaskaorig.includes(originid) || alaskadest.includes(destinationid))) {
        if (+cv3 < 5) {
          return {class3warn3: true};
        } else if (+cv3 > 20000) {
          return {class3warn5: true};
        }
      }
      if ((transportType === 'International') && (sroid !== 'DOSHW' && sroid !== 'FDICC')) {
        if (+cv3 < 1000) {
          return {class3warn4: true};
        } else if (+cv3 > 20000) {
          return {class3warn5: true};
        }
      }
      if ((transportType === 'Interstate') && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11) &&
        (alaskaorig.includes(originid) || alaskadest.includes(destinationid))) {
        if (+cv3 < 5) {
          return {class3warn3: true};
        } else if (+cv3 > 20000) {
          return {class3warn8: true};
        }
      }
      if ((transportType === 'Interstate') && (sroid !== 'DOSHW' && sroid !== 'FDICC') && (ratetypeid !== 11)) {
        if (+cv3 < 30) {
          return {class3warn6: true};
        } else if (+cv3 > 20000) {
          return {class3warn8: true};
        }
      }
      if (transportType === 'Intrastate' && (sroid === 'FDICC') && (+cv3 > 0 || cv3 === '')) {
        return {class3warn10: true};
      }
      if (transportType === 'Intrastate') {
        if (+cv3 > 0 && +cv3 < 30) {
          return {class3warn9: true};
        }
      }
    }
    return null;
  };

}

export function sitValidator(ratetypeid: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (ratetypeid === 11) {
      return null;
    }
    if (control.value !== null && (/^-?\d*\.?\d+$/).test(control.value)) {
      const sit = control.value;
      if(ratetypeid !== (9 || 10)){
        return ((+sit === 0) ? {sitzero: true} : null);
      }else if(ratetypeid === (9 || 10)){
        return ((+sit > 0) ? {sitnotzero: true} : null);
      }
      if(control.value === ""){
        return {sitzero: true};
      }
    }else{
      return {sitzero: true};
    }
    return null;
  };
}

export function uabValidator(transportType: any, ratetypeid: any,
                             originid: any, destinationid: any,
                             canadaorig: any, canadadest: any,
                             alaskaorig: any, alaskadest: any, sroid): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const uab = control.value;
    if (ratetypeid === 11) {
      return null;
    }
    if (transportType === 'International') {
      if (sroid === 'DOSHW'){
        return (+uab !== 0) ? { uabIntnlZero: true } : null;
      } else if (sroid === 'DOSSA' && +uab === 0) {
        return { uabspaces: true };
      } else {
        if(+uab === null || +uab === 0){
          return { uabspaces: true };
        } else if(+uab < 0){
          return { uabnegative: true };
        }else{
          return null;
        }
      }
    } else if (control.value !== null) {
      if (transportType === 'Interstate') {
        if (+uab >= 0) {
          if (((canadaorig.includes(originid) || alaskaorig.includes(originid)) && !(canadadest.includes(destinationid) || alaskadest.includes(destinationid)))
            || (!(canadaorig.includes(originid) || alaskaorig.includes(originid)) && (canadadest.includes(destinationid) || alaskadest.includes(destinationid)))) {
            if (+uab > 0) {
              return null;
            } else {
              return { uabcanorigzero: true };
            }
          } else {
            if (+uab === 0) {
              return null;
            } else {
              return { uabzero: true };
            }
          }
        }else{
          return {uabnegative:true}
        }
      } else if (transportType === "Intrastate") {
        if (+uab === 0) {
          return null;
        } else {
          return { uabIntnlZero: true };
        }
      }
    }
  };
}

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== null) {
      const phone = control.value;
      if (!(phone.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/))) {
        return {phone: true};
      }
    }
    return null;
  };
}
